<div class="filters" [class]="{ textDisabled: !matchId }">
  <div (click)="openFilter = !openFilter" class="hGlobal desktop">
    <p class="s3 bold">Filters</p>
  </div>
  <div (click)="openModal()" class="hGlobal tablet-or-less">
    <p class="s3 bold">
      Filters
      <app-badge
        *ngIf="filterLength > 0"
        [label]="filterLength + ''"
        color="neutral--Grey-900 textContrast amount"
      ></app-badge>
    </p>

    <app-button
      trailingIcon="plus"
      [class]="['icon', !matchId ? 'disabled' : 'ghost']"
      [style]="'min-width:unset'"
    ></app-button>
  </div>
  <app-filter-list
    [selectedCvType]="selectedCvType"
    [filterLevel]="filterLevel"
    [matchId]="matchId"
    [iterateId]="iterateId"
    [selectedSearchType]="selectedSearchType"
    [disable]="disable"
    [selectedNav]="selectedNav"
  ></app-filter-list>
</div>
